import { useContext } from 'react';
import WidgetContext from 'src/contexts/WidgetContext';

const useWidgetContext = () => {
  const context = useContext(WidgetContext);
  if (!context) {
    throw new Error('useWidgetContext must be used within a WidgetProvider');
  }
  return context;
};

export default useWidgetContext;
